// @flow
import {graphql} from 'react-relay'

import type {ID} from './types'
import createMutationPromise from './createMutationPromise'

const mutation = graphql`
  mutation ProposeOutsideMeetingMutation(
    $input: ProposeOutsideMeetingInput!
  ) {
    proposeOutsideMeeting(input: $input) {
      proposal {
        id
        databaseId
        status
        expectedResponseCount
        receivedResponseCount
      }
    }
  }
`

export type Input = {
  proposalId: ID,
}

export default (input: Input): Promise<mixed> => {
  const variables = {
    input,
  }

  return createMutationPromise({
    mutation,
    variables,
  })
}
